import React, { useState } from 'react';
import { AiOutlineMinus , AiOutlinePlus} from 'react-icons/ai';


const SingleQuestion = ({title , info}) => {
const [showInfo , setShowInfo] = useState(false);

  return (
    <div className="faq-container">
        <div className="faq-card drop-shadow-md pr-5 pb-5">
        <div className='flex pt-10 pl-10'>
            <button className='pr-5' onClick={() => setShowInfo(!showInfo)}>
                {showInfo ? <AiOutlineMinus className='text-sky-600' /> : <AiOutlinePlus />}
            </button>
            <h2 className='font-semibold text-lg leading-6'>{title}</h2>
        </div>
        {showInfo &&  <p className='pl-10 py-5 pr-5 text-sm leading-5'>{info}</p>}
        </div>
    </div>
  )
}

export default SingleQuestion